import {store} from "../../redux/storeConfig/store";

const totalCalculationCart = (data) => {
    let count = 0;
    let _total_price = 0;
    let _total_offer = 0;
    let _total_final_price = 0;
    data.map(function (cartItem, index) {
        for (let i = 1; i <= parseInt(cartItem.item_qty); i++) {
            count++;
            _total_price += cartItem.features[0].price ? parseInt(cartItem.features[0].price) : 0
            _total_offer += cartItem.features[0]?.offer ? parseInt(cartItem.features[0].offer) : 0
            _total_final_price += cartItem.features[0].final_price ? parseInt(cartItem.features[0].final_price) : 0
        }
    })
    store.dispatch({
        type: "CART",
        payload: {
            count: count,
            price: _total_final_price
        }
    });
    return {
        total_price: _total_price,
        total_offer: _total_offer,
        total_final_price: _total_final_price
    }
}
export default totalCalculationCart;